export default __webpack_public_path__ + "static/media/edit_white.c0fc6a39.svg";